export enum SESSION_STORAGE_KEYS {
  CACHE_ROCKET_FUEL_PRODUCTS = 'cacheRocketFuelProducts',
  CACHE_BUILD_SERVICES = 'cacheBuildServices',
  CACHE_SERVICES_GROWTH_STAGE = 'cacheServicesGrowthStage',
  CACHE_SERVICES_DISCIPLINES = 'cacheServicesDisciplines',
  CACHE_LEARN_SERVICES = 'cacheLearnServices',
}
